import { render, staticRenderFns } from "./RevokeBlockedModal.vue?vue&type=template&id=4699d41f"
import script from "./RevokeBlockedModal.vue?vue&type=script&lang=js"
export * from "./RevokeBlockedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports